import { Component } from '@angular/core';

@Component({
  selector: 'app-trend-to-target-idd-widget-demo',
  templateUrl: './trend-to-target-idd-widget-demo.component.html',
  styleUrl: './trend-to-target-idd-widget-demo.component.scss',
  standalone: false
})
export class TrendToTargetIddWidgetDemoComponent {
  trendToTargetIddData: any[] =  [
    { month: 1, sumIddHoursTarget: 40, sumIddHoursReached: 20 },
    { month: 2, sumIddHoursTarget: 45, sumIddHoursReached: 30 },
    { month: 3, sumIddHoursTarget: 50, sumIddHoursReached: 50 },
  ];
  
  dashStyle = 'dash';

  monthNames: string[] = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  constructor() {
    this.customizeTrendToTargetIddText = this.customizeTrendToTargetIddText.bind(this);
  }

  customizeTrendToTargetIddText(arg: any) {
    return this.monthNames[arg.value - 1];
  }
}
